import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function Impactschology() {
  return (
    <section className="solutions-schology impact-schology p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#111322" }}>
              The <span className="purple-box">Impact</span> Speaks for Itself
            </h2>
            <h4 style={{ color: "#111322" }}>
              Real-World Results After Schology’s Launch
            </h4>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-lg-0">
            <div className="sol-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="19"
                  fill="none"
                  viewBox="0 0 26 19"
                >
                  <path
                    fill="#565CCF"
                    d="M24.903 1.04a1.547 1.547 0 0 1 0 2.187L9.95 18.18a1.547 1.547 0 0 1-2.186 0L1.06 11.477A1.547 1.547 0 0 1 3.247 9.29l5.61 5.61 13.86-13.86a1.547 1.547 0 0 1 2.186 0"
                  ></path>
                </svg>
              </div>
              <h5>100+ schools onboarded</h5>
              <p>
                Schology has successfully onboarded over 100 schools, making it
                a go-to platform for educational resource management and
                communication
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="mb-4 mb-lg-0">
            <div className="sol-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="19"
                  fill="none"
                  viewBox="0 0 26 19"
                >
                  <path
                    fill="#565CCF"
                    d="M24.903 1.04a1.547 1.547 0 0 1 0 2.187L9.95 18.18a1.547 1.547 0 0 1-2.186 0L1.06 11.477A1.547 1.547 0 0 1 3.247 9.29l5.61 5.61 13.86-13.86a1.547 1.547 0 0 1 2.186 0"
                  ></path>
                </svg>
              </div>
              <h5>Improved engagement</h5>
              <p>
                Increased interaction between teachers, parents, and students,
                enhancing academic performance tracking and communication.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={4} xl={4} xxl={4} className="">
            <div className="sol-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="19"
                  fill="none"
                  viewBox="0 0 26 19"
                >
                  <path
                    fill="#565CCF"
                    d="M24.903 1.04a1.547 1.547 0 0 1 0 2.187L9.95 18.18a1.547 1.547 0 0 1-2.186 0L1.06 11.477A1.547 1.547 0 0 1 3.247 9.29l5.61 5.61 13.86-13.86a1.547 1.547 0 0 1 2.186 0"
                  ></path>
                </svg>
              </div>
              <h5>Enhanced parent-school collaboration</h5>
              <p>
                The parent module facilitated better visibility into student
                activities and school announcements, leading to stronger
                collaboration and engagement.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Impactschology;
